// extracted by mini-css-extract-plugin
module.exports = {"Last":"LastOpen_Last__25HNS"};